import { ref, onMounted } from '@vue/composition-api'
import draftApi from '@/services/api/drafts'

export default function useDraftStates() {
  const states = ref([])
  const loading = ref(false)

  async function fetch() {
    loading.value = true
    try {
      const res = await draftApi.states()
      states.value = res.data.data
    } finally {
      loading.value = false
    }
  }

  onMounted(fetch)

  return { states, loading }
}



// WEBPACK FOOTER //
// ./src/composables/drafts/useDraftStates.js